import React from 'react';
import { gettext, dangerousGettext } from '@eventbrite/i18n';
import { getHost, getLocale } from './utils';
import { getPricesForTLD } from './pricingAndPackagingUtils';
import { Typography } from '@eventbrite/marmalade';
import getDiscovered from '../static/images/getDiscovered.webp';
import buildBuzz from '../static/images/buildBuzz.webp';
import engageAttendees from '../static/images/engageAttendees.webp';
import './InfoCards.scss';

const getInfoCards = () => {
    const priceMapping = getPricesForTLD();
    const locale = Intl.NumberFormat().resolvedOptions().locale;
    return [
        {
            image: getDiscovered,
            headerText: gettext('Get discovered'),
            bodyContent: (
                <>
                    <p>
                        {gettext(
                            'Our powerful discovery platform automatically showcases your public events, connecting you with local event seekers looking for new experiences.',
                        )}
                    </p>
                </>
            ),
        },
        {
            image: buildBuzz,
            headerText: gettext('Build buzz'),
            bodyContent: (
                <>
                    <p>
                        {gettext(
                            'We help you build a loyal following by notifying your Eventbrite followers when you add new events. Also, ticket-buyers receive personalized event recommendations tailored to their interests and location through email and our app.',
                        )}
                    </p>
                </>
            ),
        },
        {
            image: engageAttendees,
            headerText: gettext('Engage attendees'),
            bodyContent: (
                <>
                    <p>
                        {gettext(
                            'Eventbrite ensures your attendees never miss a beat with event reminder emails, subscriber lists that auto-update with your past attendees, and cart abandonment emails so potential ticket-buyers never slip through the cracks.',
                        )}
                    </p>
                </>
            ),
        },
    ];
};

export const InfoCard = ({ image, headerText, bodyContent }) => {
    return (
        <div className="pricing-and-packaging-info-card">
            <img src={image} className="info-card-image" loading="lazy" />
            <Typography variant="heading-sm" className="info-card-header">
                {headerText}
            </Typography>
            <Typography variant="body-md" className="info-card-content">
                {bodyContent}
            </Typography>
        </div>
    );
};

export const InfoCards = () => {
    return (
        <div className="pricing-and-packaging-cards-parent">
            <Typography variant="heading-lg" className="cards-title" as="span">
                <div
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: gettext(
                            'Your  <span style="color:#D1410C;">#1 partner</span> in event success',
                            { styleToggle: 'cards-title-span' },
                        ).toString(),
                    }}
                />
            </Typography>
            <Typography variant="body-lg" className="cards-description">
                {gettext(
                    'We put event management on auto-pilot, so you can focus on creating unforgettable experiences',
                )}
            </Typography>
            <div className="pricing-and-packaging-cards">
                {getInfoCards().map((cardProps, i) => (
                    <InfoCard key={i} {...cardProps} />
                ))}
            </div>
        </div>
    );
};

export default InfoCards;
